import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Course } from 'src/app/shared/models/course';
import { PrivilegeType } from 'src/app/shared/models/domain';
import { CommonService } from 'src/app/shared/services/common.service';
import { CourseService } from 'src/app/shared/services/course.service';
import { CourseQuestionCrudComponent } from '../course-question-crud/course-question-crud.component';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-course-question-list',
  templateUrl: './course-question-list.component.html',
  styleUrls: ['./course-question-list.component.scss']
})
export class CourseQuestionListComponent implements OnInit {

   public courses: Course[] = [];
     public isLoading: boolean = true;
     public searchKeyword: string = "";
     public privilege: PrivilegeType;
     constructor(
       private modalService: NgbModal,
       private commonService: CommonService,
       private courseService: CourseService,
       private dataService: DataService,
     ) { }
  
    ngOnInit(): void {
      this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
      this.getCourses();
    }
    
    private getCourses(clear: boolean = true) {
       if (clear) {
         this.isLoading = true;
         this.courses = [];
       }
       this.courseService.getCourses().subscribe({
         next: (courses: Course[]) => {
           this.courses = courses.sort((a, b) => a.id - b.id);
           this.isLoading = false;
         },
         error: (error: HttpErrorResponse) => {
           this.isLoading = false;
           this.commonService.setToastr(500, error?.error?.name || error.error);
         }
       });
     }
   
     public upsertCourse(course?: Course) {
       if (!this.privilege.canEdit) return;
       const modalRef = this.modalService.open(CourseQuestionCrudComponent, { size: 'xl', backdrop: 'static' });
       modalRef.componentInstance.course = course;
       modalRef.componentInstance.courses = this.courses.filter(t => t.id !== course?.id);
     }
}
